<template>
  <div>
    <TemplateStepFormulario
      v-if="carregado"
      :data="data"
      :idFuncionalidade="idFuncionalidade"
      :step="step"
      :step-count="stepCount"
      :step-end="stepEnd"
      @proximo="proximo"
    />
  </div>
</template>
<script>
import TemplateStepFormulario from '@/components/TemplateSolicitacao/steps/TemplateStepFormulario'
import { mapGetters } from 'vuex'

export default {
  name: 'TemplateStepIdentificacao',
  components: { TemplateStepFormulario },
  props: {
    step: {
      type: Object
    },
    titulo: {
      type: String
    },
    idFuncionalidade: {
      type: [Number, String],
      default: -23
    },
    data: {
      default: () => ({})
    },
    stepCount: {
      type: [Number, String],
      default: 1
    },
    stepEnd: {
      type: [Number, String],
      default: 1
    }
  },
  computed: {
    ...mapGetters('Login', ['isLogin'])
  },
  data () {
    return {
      carregado: false
    }
  },
  methods: {
    verificaBypass () {
      if (this.isLogin) {
        return this.bypass()
      }

      this.carregado = true
    },
    bypass () {
      const payloadStep = {
        bypass: true
      }
      this.$emit('proximo', payloadStep)
    },
    proximo (formularioPayload) {
      const payloadStep = {
        formData: formularioPayload.formData
      }
      this.$emit('proximo', payloadStep)
    }
  },
  mounted () {
    this.verificaBypass()
  }
}
</script>
<style scoped>
</style>
